// Education List Filter
let educationFilterBtns = document.querySelectorAll('.educations-list .filter-btn');
let educationCards = document.querySelectorAll('.educations-list .education-card');

if(educationFilterBtns.length > 0 && educationCards.length > 0) {
    educationFilterBtns.forEach(function(button) {
        button.addEventListener('click', function(e) {
            e.preventDefault();

            let filterValue = this.getAttribute('data-filter');

            // Update active state on buttons
            educationFilterBtns.forEach(function(btn) {
                btn.classList.remove('active');
            });
            this.classList.add('active');

            // Filter cards
            educationCards.forEach(function(card) {
                let cardCategories = card.getAttribute('data-categories').split(',');

                if (filterValue === 'all') {
                    // Show all cards
                    card.classList.remove('hidden');
                } else {
                    // Show only cards that match the selected category
                    if (cardCategories.includes(filterValue)) {
                        card.classList.remove('hidden');
                    } else {
                        card.classList.add('hidden');
                    }
                }
            });
        });
    });
}
